<template>
  <div>
    <Info />
    <ItemTable
      :visibleItems=visibleItems
      :invisibleItems=invisibleItems
      :col1=col1
      :col2=col2
      :col3=col3
      :isDisplayItem=isDisplayItem
      :isHideCol=true
      @setQuantity=setQuantity
      type="delivery"
    />
    <ShowHiddenItemBtn :isDisplayItem=isDisplayItem @clickShowHiddenItemBtn="clickShowHiddenItemBtn"></ShowHiddenItemBtn>
    <ButtonBar @back="back" @next="next"></ButtonBar>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ItemTableCol from '@/models/ItemTableCol';

  export default {
    name: 'RefrigeratedDelivery',
    created() {
      this.$parent.title = '';
      this.$parent.imageName = 'refrigeratedDelivery';
      this.$parent.hasMaintenancne = true;
      this.$parent.showMaintenanceInformation = true;
      alert('納品を開始してください');
    },
    computed: {
      ...mapGetters([
        'prepareQuantities',
        'takeoutQuantities',
        'recallQuantities',
      ]),
      visibleItems() {
        return this.items.filter(item => item.lastDeliveryQuantity > 0 || item.prepareQuantity > 0);
      },
      invisibleItems() {
        return this.items.filter(item => item.lastDeliveryQuantity <= 0 && item.prepareQuantity <= 0);
      },
    },
    data() {
      return {
        items: this.$store.getters.items(2),
        isDisplayItem: false,
        col1: new ItemTableCol(
          '納品予定数',
          'prepare',
          this.$store.getters.prepareQuantities,
        ),
        col2: new ItemTableCol(
          '持ち帰り数',
          'takeout',
          this.$store.getters.takeoutQuantities,
        ),
        col3: new ItemTableCol(
          '回収数',
          'recall',
          this.$store.getters.recallQuantities,
        ),
        backPageName: this.$store.getters.routes.refrigeratedDelivery.back,
        nextPageName: this.$store.getters.routes.refrigeratedDelivery.next,
      };
    },
    methods: {
      back() {
        this.$router.push({ name: this.backPageName });
      },
      next() {
        let error_messages = [];
        let takeout_item_count = 0;
        let takeout_item_quantity = 0;
        Object.values(this.items).some((item) => {
          if (this.takeoutQuantities[item.itemId] > this.prepareQuantities[item.itemId]) {
            error_messages.push('持ち帰り数が予定納品数を超えています');
            return true;
          }

          if (this.takeoutQuantities[item.itemId] > 0) {
            takeout_item_count++;
            takeout_item_quantity += this.takeoutQuantities[item.itemId];
          }
        });

        if (error_messages.length > 0) {
          alert(error_messages.join('\r'));
          return false;
        }

        if (!window.confirm(`持ち帰り数は${takeout_item_count}種類、合計${takeout_item_quantity}個です`)) {
          return true;
        }

        this.$router.push({ name: this.nextPageName });
        return true;
      },
      clickShowHiddenItemBtn() {
        this.isDisplayItem = !this.isDisplayItem;
      },
      setQuantity(type, itemId, quantity) {
        if (type === 'takeout') {
          if (quantity > this.prepareQuantities[itemId]) {
            document.getElementById('takeout' + itemId).classList.add('error');
          } else {
            document.getElementById('takeout' + itemId).classList.remove('error');
          }
        }

        if (this[`${type}Quantities`][itemId] === quantity) return false;
        this.$store.dispatch('setQuantity', { type, itemId, quantity });
        return true;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/RefrigeratedDelivery.vue?7d7d0480